'use client';

import { Menu as BaseMenu } from '@base-ui/react/menu';

import { type ZeusHTMLProps } from '../../internal/types/html-props';
import { type Component, type ComponentProps } from '../../types/component';

interface MenuTriggerBaseProps {
  /**
   * Function that renders the trigger for the Menu. It receives `props` and `state` as parameters.
   *
   * @param props - The props to apply to the trigger element for the Menu.
   * @param state.isOpen - Whether the Menu is open or closed.
   *
   * @return The trigger element.
   */
  render: (
    props: ZeusHTMLProps,
    state: { readonly isOpen: boolean }
  ) => React.ReactElement;
}

type MenuTriggerProps = ComponentProps<MenuTriggerBaseProps>;

type MenuTriggerComponent = Component<MenuTriggerBaseProps>;

const MenuTrigger: MenuTriggerComponent = (props) => {
  const { render } = props;

  return (
    <BaseMenu.Trigger
      render={(baseProps, baseState) =>
        render(baseProps as ZeusHTMLProps, { isOpen: baseState.open })
      }
    />
  );
};

MenuTrigger.displayName = 'Menu.Trigger';

export { MenuTrigger, type MenuTriggerProps, type MenuTriggerBaseProps };
